import * as ResizeObserver from 'resize-observer-polyfill';
// import ResizeObserver from 'resize-observer-polyfill';
import { noop } from '.';
export var safelyCreateResizeObserver = function (resizeCb) {
    try {
        // Looks like weird things happen when RO plays with jsdom.
        // https://github.com/que-etc/resize-observer-polyfill/issues/34
        // Because we create modals in many places, here seemed a good place to ensure
        // safe initialization in RO
        var w = window;
        if (!w.SVGElement) {
            w.SVGElement = HTMLElement;
        }
        var RO = ResizeObserver.default ? ResizeObserver.default : ResizeObserver;
        var resizeObserver_1 = new RO(function (observedElements) {
            observedElements.forEach(function (elem) {
                var _a = elem.contentRect, width = _a.width, height = _a.height;
                resizeCb(width, height);
            });
        });
        return {
            observeElem: function (elem) { return resizeObserver_1.observe(elem); },
            unobserveElem: function (elem) { return resizeObserver_1.unobserve(elem); },
            clean: function () { return resizeObserver_1.disconnect(); }
        };
    }
    catch (e) {
        console.warn(e);
        return {
            observeElem: function (_) { return noop(); },
            unobserveElem: function (_) { return noop(); },
            clean: function () { return noop(); }
        };
    }
};
export var createResizeObserver = function (resizeCb) {
    return safelyCreateResizeObserver(resizeCb);
};
//# sourceMappingURL=resize-observer.js.map